// extracted by mini-css-extract-plugin
export var container = "text-module--container--3mcgY";
export var iframe = "text-module--iframe--1mt8u";
export var img = "text-module--img--BfGtX";
export var expoimg = "text-module--expoimg--Q5HsB";
export var date = "text-module--date--fbVeT";